import React from 'react';
import { SkeletonButton } from '@bb/elements-web';

const FooterSkeleton = () => (
  <SkeletonButton
    style={{
      margin: '0 auto 25px auto',
      width: 250,
      height: 45,
      display: 'block',
    }}
    block
  />
);

export default FooterSkeleton;
